
import React from "react";

export function HotlineNumberListHeader() {
    return (
        <div className={"w-full"}>
            <div className="grid grid-cols-4 w-full gap-8">
                <div>Name</div>
                <div>Phone Number</div>
                <div>In Use</div>
                <div>Actions</div>
            </div>
            <hr className={"mt-4 w-full"}/>
        </div>

    )
}